import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { approveRouteRef, detailRouteRef, rootRouteRef } from './routes';

export const requestTrackerPlugin = createPlugin({
  id: 'request-tracker',
  routes: {
    root: rootRouteRef,
    detail: detailRouteRef,
    approve: approveRouteRef,
  },
});

/**
 * Single routable extension mounted at `/request-tracking`. It renders an
 * internal router that switches between the tabbed list view, the request
 * detail page, and the token-based approval page (for email links).
 */
export const RequestTrackerPage = requestTrackerPlugin.provide(
  createRoutableExtension({
    name: 'RequestTrackerPage',
    component: () => import('./components/Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
